// @flow

import breeam from './img/KeyDateImage/breeam.png';
import cityNews from './img/KeyDateImage/city-news.png';
import construction from './img/KeyDateImage/construction.png';
import designer from './img/KeyDateImage/designer-gallery-active.png';
import dinningExperience from './img/KeyDateImage/dinning-experience.png';
import fresh from './img/KeyDateImage/fresh.png';
import inoguration from './img/KeyDateImage/inoguration.png';
import opening from './img/KeyDateImage/opening.png';
import refurbishment from './img/KeyDateImage/refurbishment.png';
import specialEvent from './img/KeyDateImage/special-event.png';
import stars from './img/KeyDateImage/stars.png';
import transport from './img/KeyDateImage/transport.png';

import HOTEL from './img/kpi/hotel.png';
import PARKING from './img/kpi/parking.png';
import RESIDENTIAL_HOUSING from './img/kpi/housing.png';
import WORK_PLACES from './img/kpi/workplace.png';
import BUILDINGS from './img/kpi/buildings.png';
import CASINO from './img/kpi/casino.png';
import CRUISE_TERMINAL from './img/kpi/ship.png';
import INVESTMENT from './img/kpi/investment.png';
import GLA from './img/kpi/gla.png';
import PARKING_SPACE from './img/kpi/parking spaces.png';
import STORES from './img/kpi/stores.png';
import SUPERMARKET from './img/kpi/supermarket.png';
import SCREENS from './img/kpi/screens.png';
import VISITS from './img/kpi/visits.png';

import {
  ACCESS_PLAN,
  BEST_OF,
  BROCHURE_PLAN,
  BROCHURES,
  CORPORATE_BROCHURES,
  DESTINATION,
  EVENTS,
  EXTERIOR,
  ICONIC_SHOP_FRONT,
  INTERIOR,
  LEASING_PLAN,
  LOGO,
  PROJECT_PLAN,
  PROJECTS,
  SPHERICAL_OLD_FORMAT,
  VIDEO,
  VIRTUAL_VISITS,
} from './utils/keepeekUtils';
import { MALL_BASE, MALL_INFO } from './path/mallPath';
import { OFFICE_BASE, OFFICE_INFO } from './path/officePath';
import {
  HEADER_EVENTS,
  HEADER_FLOW,
  HEADER_GROUP_OVERVIEW,
  HEADER_INFO,
  HEADER_INVESTORS,
  HEADER_MAP,
  HEADER_MEDIA,
  HEADER_PERF,
  HEADER_SHOPPING_CENTERS,
} from './path/headerPaths';
import { WORLD_BASE } from './path/worldPaths';
import { AREA_BASE } from './path/areaPath';
import { STORE_BASE } from './path/storePath';

export const reconciliationStates = {
  OK: 'OK',
  MAPPED: 'MAPPED',
  EMPTY_UNIT: 'EMPTY_UNIT',
  MULTIPLE_LUX: 'MULTIPLE_LUX',
  MULTIPLE_MERCURY: 'MULTIPLE_MERCURY',
  UNMAPPED: 'UNMAPPED',
  MAPPING: 'MAPPING',
  MERCURY_ONLY: 'MERCURY_ONLY',
  LUX_ONLY: 'LUX_ONLY',
  RETAILER_MISSING: 'RETAILER_MISSING',
  FLAGGED: 'FLAGGED',
  UNFLAGGED: 'UNFLAGGED',
  HISTORY: 'HISTORY',
  MERCURY_OK_UNMAPPED: 'MERCURY_OK_UNMAPPED',
};

export const reconciliationAction = {
  MAPPED: 'MAPPED',
  UNMAP: 'UNMAP',
};

export const reconciliationFlag = {
  CLOSING: 'CLOSING',
  OPENING: 'OPENING',
  OTHER: 'OTHER',
  VACANT: 'VACANT',
};

export const kpiImage = {
  HOTEL,
  PARKING,
  RESIDENTIAL_HOUSING,
  WORK_PLACES,
  BUILDINGS,
  CASINO,
  CRUISE_TERMINAL,
  INVESTMENT,
  GLA,
  PARKING_SPACE,
  STORES,
  SUPERMARKET,
  SCREENS,
  VISITS,
};

export const isMobile = (navigator.platform.indexOf('iPhone') != -1) ||
  (navigator.platform.indexOf('iPad') != -1) ||
  (navigator.platform.indexOf('iPod') != -1) ||
  (navigator.userAgent.indexOf('Android') != -1);

export const twCurrency = 'tw_currency';
export const twSurfaceUnit = 'tw_surface_unit';
export const defaultCurrency = 'EUR';
export const defaultSurfaceUnit = 'm';
export const cookieDefaultDate = new Date('2099-12-31T23:59:59');

export const SU = {
  label: 'SU',
  lowercase: 'su',
  minGLA: 0,
  maxGLA: 500,
};

export const MSU = {
  label: 'MSU',
  lowercase: 'msu',
  minGLA: 501,
  maxGLA: 1000,
};

export const LU = {
  label: 'LU',
  lowercase: 'lu',
  minGLA: 1001,
  maxGLA: 500000,
};

export const COUNTRIES = {
  Austria: {
    id: 'austria',
    label: 'AUSTRIA',
    lat: 47.7972996,
    long: 13.3562275,
    zoom: 7,
    countryCodeList: ['AT'],
  },
  CentralEurope: {
    id: 'central-europe',
    label: 'CENTRAL EUROPE',
    lat: 51.3032159,
    long: 20.2741699,
    zoom: 7,
    countryCodeList: ['CZ', 'GE', 'HU', 'PL', 'SK'],
  },
  France: {
    id: 'france',
    label: 'FRANCE',
    lat: 48.8517998,
    long: 2.3799168,
    zoom: 10,
    countryCodeList: ['FR'],
  },
  Germany: {
    id: 'germany',
    label: 'GERMANY',
    lat: 51.0701955,
    long: 9.1215332,
    zoom: 7,
    countryCodeList: ['DE', 'D3'],
  },
  Netherlands: {
    id: 'netherlands',
    label: 'NETHERLANDS',
    lat: 51.565776,
    long: 5.0267816,
    zoom: 7,
    countryCodeList: ['BE', 'NL'],
  },
  Nordics: {
    id: 'nordics',
    label: 'NORDICS',
    lat: 61.3158794,
    long: 24.0854783,
    zoom: 5,
    countryCodeList: ['DK', 'SE'],
  },
  Spain: {
    id: 'spain',
    label: 'SPAIN',
    lat: 39.8924376,
    long: -3.7151757,
    zoom: 7,
    countryCodeList: ['ES'],
  },
  UK: {
    id: 'uk',
    label: 'UNITED KINGDOM',
    lat: 54.4351582,
    long: -3.5691022,
    zoom: 6,
    countryCodeList: ['GB'],
  },
  USA: {
    id: 'usa',
    label: 'UNITED STATES',
    lat: 40.6914594,
    long: -97.7940413,
    zoom: 5,
    countryCodeList: ['US'],
  },
};
export const eventTypeIcon = {
  Inauguration: inoguration,
  Refurbishment: refurbishment,
  Construction: construction,
  Extension: construction,
  'Special event': specialEvent,
  Acquisition: inoguration,
  Opening: opening,
  'Opening iconic shop': opening,
  'Opening Dining Experience': dinningExperience,
  '4 Star Label': stars,
  'Opening Fresh !': fresh,
  Breeam: breeam,
  'Opening Designer Gallery': designer,
  Transport: transport,
  'Major city news': cityNews,
};

export const branchLevelColor = {
  10: 'rgb(248, 117, 166)',
  11: 'rgb(232, 0, 28)',
  12: 'rgb(146, 145, 255)',
  13: 'rgb(123, 12, 145)',
  14: 'rgb(255, 255, 206)',
  15: 'rgb(120, 225, 255)',
  16: 'rgb(255, 239, 88)',
  17: 'rgb(149, 255, 13)',
  18: 'rgb(219, 219, 128)',
  19: 'rgb(12, 123, 256)',
  20: 'rgb(192, 238, 186)',
  21: 'rgb(252, 187, 82)',
  22: 'rgb(224, 223, 255)',
  23: 'rgb(193, 255, 255)',
  24: 'rgb(251, 197, 255)',
  25: 'rgb(214, 15, 123)',
  26: 'rgb(145, 94, 47)',
  27: 'rgb(108,116,151)',
  28: 'rgb(255,121,8)',
};

export const TOP_LEVEL_CATEGORIES = {
  'Food Retail': {
    color: '#4e79a7',
    additionalInfo: '',
  },
  Fashion: {
    color: '#a0cbe8',
    additionalInfo: 'Fashion Women, Men & Kids',
  },
  Electronics: {
    color: '#f28e2b',
    additionalInfo: 'Household and personal gadgets - ie. laptop, phone, TV',
  },
  Footwear: {
    color: '#59a14f',
    additionalInfo: '',
  },
  'General Retail': {
    color: '#f1ce63',
    additionalInfo: '',
  },
  Homewares: {
    color: '#499894',
    additionalInfo: '',
  },
  Jewellery: {
    color: '#e15759',
    additionalInfo: '',
  },
  'Leisure Goods': {
    color: '#79706e',
    additionalInfo: '',
  },
  'Personal Care': {
    color: '#fabfd2',
    additionalInfo: 'Beauty',
  },
  'Food catering': {
    color: '#d4a6c8',
    additionalInfo: '',
  },
  default: {
    color: '#ff9d9a',
    additionalInfo: '',
  },
};

export const unMappedColor = '#3AA6FA';

export const retailerMissingColor = '#0047AB';

export const emptyUnitColor = '#fa0001';

export const multipleLux = '#faec00';

export const transitionningStage = '#FABA3A';

export const manuallyFlagged = '#ff6dc5';

export const manuallyMapped = '#24d986';

export const presentationName = {
  medias: 'Medias',
  videos: 'Videos',
  countriesBrochuresMedias: 'Countries Brochures Media',
  countriesVideos: 'Countries Videos',
};

export const layoutGalleries = [LEASING_PLAN, ACCESS_PLAN, PROJECT_PLAN, LOGO];
export const pictureGalleries = [INTERIOR, EXTERIOR, EVENTS,
  ICONIC_SHOP_FRONT, BEST_OF, DESTINATION, PROJECTS];
export const videoGalleries = [VIDEO];
export const brochuresGalleries = [BROCHURES, BROCHURE_PLAN, CORPORATE_BROCHURES];
export const virtualVisitsGalleries = [VIRTUAL_VISITS, SPHERICAL_OLD_FORMAT];

export const assetTypes = {
  shoppingCenter: {
    type: 'SC',
    path: `${MALL_INFO}?mall=`,
    icon: 'fa-store-alt',
  },
  office: {
    type: 'OF',
    path: `${OFFICE_INFO}?office=`,
    icon: 'fa-building',
  },
};

export const assetFeatures = {
  fourStars: {
    name: '4 stars',
    id: '1',
  },
  dining: {
    name: 'Dining Experience',
    id: '2',
  },
  cinema: {
    name: 'Cinema',
    id: '3',
  },
  fresh: {
    name: 'Fresh !',
    id: '4',
  },
  designer: {
    name: 'Designer Gallery',
    id: '5',
  },
  development: {
    name: 'In development',
    id: '6',
  },
  refurbishment: {
    name: 'Refurbishment',
    id: '7',
  },
  extension: {
    name: 'Extension',
    id: '8',
  },
  bream: {
    name: 'Breeam',
    id: '9',
  },
  family: {
    name: 'Family Experience',
    id: '10',
  },
  westfield: {
    name: 'Westfield',
    id: '11',
  },
};

export const ENVIRONMENT = {
  dev: 'Développement',
  int: 'Intégration',
  preprod: 'Pré-production',
  prod: 'Production',
};

export const geminiColors = {
  veryVeryLow: '#33cc33',
  veryLow: '#99ff33',
  low: '#ffff25',
  high: '#ffbf00',
  veryHigh: '#ff6600',
  veryVeryHigh: '#d62d20',
};

export const currenciesSymbols = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  AED: 'د.إ',
  SEK: 'kr',
  CZK: 'Kč',
  HKD: 'HK$',
  DKK: 'kr.',
  RUB: '₽',
  BRL: 'R$',
  CAD: 'CA$',
  SGD: 'SG$',
  AUD: 'AU$',
  CNY: '¥',
  PLN: 'zł',
  PHP: '₱',
};

export const visioglobeWhiteTextColor = '#d9d9d9';

export const visioGlobeUnselectedColor = '#d6d6d6';
export const visioGlobeDefaultColor = '#FFF';
export const visioGlobeDefaultEmptyColor = '#0FF';
export const visioGlobeSelectedColor = '#cf13c6';
export const visioGlobeGoodwillSelectedColor = '#bb14b2';
export const visioGlobeLocomotiveColor = '#2b362b';
export const visioGlobeEmptyUnitColor = '#d62d20';

export const shoppingCenter = 'shoppingCenter';
export const branch = 'branch';
export const shop = 'shop';
export const zone = 'zone';
export const all = 'kpi';

export const BL_TYPE = {
  BL1: 'bl1',
  BL2: 'bl2',
  BL3: 'bl3',
  OTHER_BL: 'otherbl',
  UNCONCERNED: 'unconcerned',
};

export const ANCHORS_MIN_GLA = 1000;

export const BUSINESS_PLAN_COLORS = {
  Renewal: '#1469b3',
  'Termination of Lease': '#d62d20',
  'Letting - Reletting': '#33cc33',
  'Rent Review': '#ffff25',
  'Letting - First Letting': '#99ff33',
  'Lease Modification': '#ffbf00',
};

export const BUSINESS_PLAN_COLORS_BEM = {
  selected: '--selected',
  Renewal: '--renewal',
  'Termination of Lease': '--lease-termination',
  'Letting - Reletting': '--letting-reletting',
  'Rent Review': '--rent-review',
  'Letting - First Letting': '--first-letting',
  'Lease Modification': '--lease-modification',
};

export const BUSINESS_PLAN_CATEGORIES = {
  RENEWAL: 'Renewal',
  TERMINATION_OF_lEASE: 'Termination of Lease',
  LETTING_RELETTING: 'Letting - Reletting',
  RENT_REVIEW: 'Rent Review',
  LETTING_FIRST_LETTING: 'Letting - First Letting',
  LEASE_MODIFICATION: 'Lease Modification',
};

export const CUSTOMER_PROFILES_COLORS = {
  'Affluent incomes': '#678ff6',
  'Middle incomes': '#c1cd43',
  'Lower incomes': '#f6dc4b',
};

export const CUSTOMER_PROFILES_TOTAL_COLORS = {
  'Affluent incomes': '#a4b3da',
  'Middle incomes': '#cacea5',
  'Lower incomes': '#dcd4a8',
};

export const GOODWILL_RATIOS = {
  PROXIMITY: 'proximityRatio',
  SYSTEMATIC: 'systematicRatio',
  SYNERGIC: 'synergicRatio',
  TOTAL: 'totalRatio',
  GOODWILL_REACHABLE: 'totalGoodwillReachableAfterCeiling',
};

export const ATTRACTIVE_SCORE_RADAR_CHART_STYLE = {
  textColor: '#d62d20',
  backgroundColor: 'rgba(214,45,32,0.4)',
  hoverColor: '#fff',
  titleFontSize: 20,
};

export const OCR_QUANTIL_LEGEND = {
  q0: 'N/A',
  q1: '0 %',
  q2: '10 %',
  q3: '15 %',
  q4: '20 %',
  q5: '25 %',
  q6: '100 %',
};

export const OCR_QUANTIL_VALUE = {
  veryLow: 10,
  low: 15,
  high: 20,
  veryHigh: 25,
};

export const OCR_QUANTIL_COLOR = {
  veryVeryLow: '#caaae4',
  veryLow: '#9fdb70',
  low: '#ffff7f',
  high: '#ffbf00',
  veryHigh: '#faa094',
  veryVeryHigh: '#d90839',
};

export const dimensions = {
  m: {
    convertorTo: 'square meters',
    symbol: 'm²',
    convertorFactor: 1,
  },
  ft: {
    convertorTo: 'square foots',
    symbol: 'ft²',
    convertorFactor: 10.7639104167097,
  },
};

export const isochronousZones = {
  '0-10': '10-',
  '10-20': '20',
  '20-30': '30',
  '30-40': '40',
  '40-50': '50',
  '50-60': '60',
  '60+': '60+',
};

export const SliderEnum = {
  INFO: 'info',
  PERF: 'perf',
  MAP: 'map',
  SHOPPING_CENTER: 'shoppingCenter',
  FLOW: 'flow',
  // SHOPPERS: 'shoppers',
  GROUP_OVERVIEW: 'groupOverview',
  INVESTORS: 'investors',
  MARKETING: 'marketing',
  MEDIA: 'media',
  EVENTS: 'events',
};

export const sliderHeader = {
  [SliderEnum.INFO]: {
    name: 'header.INFO',
    url: HEADER_INFO,
  },
  [SliderEnum.PERF]: {
    name: 'header.PERF',
    url: HEADER_PERF,
  },
  [SliderEnum.MAP]: {
    name: 'header.MAP',
    url: HEADER_MAP,
  },
  [SliderEnum.SHOPPING_CENTER]: {
    name: 'header.SHOPPING_CENTERS',
    url: HEADER_SHOPPING_CENTERS,
  },
  [SliderEnum.FLOW]: {
    name: 'header.FLOW',
    url: HEADER_FLOW,
  },
  // [SliderEnum.SHOPPERS]: {
  //   name: 'header.SHOPPERS',
  //   url: HEADER_SHOPPERS,
  // },
  [SliderEnum.GROUP_OVERVIEW]: {
    name: 'header.GROUP_OVERVIEW',
    url: HEADER_GROUP_OVERVIEW,
  },
  [SliderEnum.INVESTORS]: {
    name: 'header.INVESTORS',
    url: HEADER_INVESTORS,
  },
  // [SliderEnum.MARKETING]: {
  //   name: 'header.MARKETING',
  //   url: HEADER_MARKETING,
  // },
  [SliderEnum.MEDIA]: {
    name: 'header.MEDIA',
    url: HEADER_MEDIA,
  },
  [SliderEnum.EVENTS]: {
    name: 'header.EVENTS',
    url: HEADER_EVENTS,
  },
};

export const HeaderEnum = {
  WORLD: 'world',
  AREA: 'area',
  MALL: 'mall',
  OFFICE: 'office',
  STORE: 'store',
};

export const headerBase = {
  [HeaderEnum.WORLD]: {
    url: WORLD_BASE,
    headers: [
      SliderEnum.MAP,
      SliderEnum.GROUP_OVERVIEW,
      SliderEnum.INVESTORS,
      // SliderEnum.MARKETING,
      SliderEnum.EVENTS,
    ],
    position: 0,
  },
  [HeaderEnum.AREA]: {
    url: AREA_BASE,
    headers: [
      SliderEnum.MAP,
    ],
    position: 1,
  },
  [HeaderEnum.MALL]: {
    url: MALL_BASE,
    headers: [
      SliderEnum.INFO,
      SliderEnum.PERF,
      SliderEnum.MAP,
      // SliderEnum.SHOPPERS,
      SliderEnum.MEDIA,
      SliderEnum.EVENTS,
    ],
    position: 2,
  },
  [HeaderEnum.OFFICE]: {
    url: OFFICE_BASE,
    headers: [
      SliderEnum.INFO,
      SliderEnum.MEDIA,
    ],
    position: 2,
  },
  [HeaderEnum.STORE]: {
    url: STORE_BASE,
    headers: [
      SliderEnum.INFO,
    ],
    position: 3,
  },
};

export const mappingKpiName = {
  ocr: 'GEMINI.OCR',
  salesR12m: 'GEMINI.SALES',
  salesR12mWithoutSst: 'GEMINI.SALES_WITHOUT',
  glaWithSst: 'GEMINI.GLA',
  glaWithoutSst: 'GEMINI.GLA_WITHOUT',
  erv: 'GEMINI.ERV',
  spotMgr: 'GEMINI.MGR',
  revPot: 'GEMINI.REV_POT',
  invSbr: 'GEMINI.SBR',
  occupancyCost: 'GEMINI.OCC_COST',
};

export const embeddedUrlPage = {
  media: 'media',
  investor: 'investor',
  group: 'group',
};
